/* eslint-disable @typescript-eslint/no-explicit-any */
// PJL_LATER_TODO rename to permissions

// DeprecateME use PermissionService

import { PermissionEnum } from '@orgbrain/roles';

import { IdentityType } from '@orgbrain/lib-data';
import { CurrentUser, Organization } from './lib-admin';
import { hasCurrentUserPermissions } from './rescued-from-roles';

// See if user has any role in organization using orgId
// Deprecate and use userHasOrgPermissionById  TODO: deprecate
export const userHasOrgPermission = function (
  permission: PermissionEnum,
  user: CurrentUser,
  orgId: string
): boolean {
  return hasCurrentUserPermissions({
    currentUser: user,
    permissions: [permission],
    orgId,
  });
};

// This is hack so we can see board memebers Id requirements
export const userHasRequiredIdOrg = function (user: CurrentUser, org: Organization): boolean {
  const newUser = { ...user };

  newUser.organizations = [org as any];

  const result = userHasRequiredOrgAuth({ user, organizationId: org._id.toString() });
  return result.ok;
};

// Core functionality to share front/backend
// If requiredId is present it overrides org.requiredId
export const userHasRequiredOrgAuth = function ({
  user,
  organizationId,
  requiredId,
}: {
  user: CurrentUser;
  organizationId: string;
  requiredId?: IdentityType[]; // if present overrides org.requiredId
}): { ok: boolean; data: any } {
  if (!user || !user.organizations) {
    throw new Error(` userNeedsIdPermission()  no user `);
  }

  const overRideOrgId = !organizationId; // I really have no idea what this is here for  I removed check for !requiredId that was here previously but maybe this is all nonsense.

  if (!requiredId) {
    if (!user.organizations) {
      throw new Error(` userNeedsIdPermission()  no user OR no organizations in user `);
    }

    const org = user.organizations.find((item) => item._id.toString() === organizationId);
    if (!org) {
      throw new Error(` userNeedsIdPermission() did not find ${organizationId}  in user data`);
    }

    if (!(org.requiredId && org.requiredId.length) && !requiredId) {
      return { ok: true, data: 'Id not required for this organization' };
    }
    requiredId = org.requiredId;
  }

  const hasManualId = organizationId
    ? user.manualIdMap && user.manualIdMap[organizationId]?.active
    : false;

  if (hasManualId && !overRideOrgId) {
    // Hack to make behaviour as before PJL mods 2023-01-21
    return { ok: true, data: ' Manual id set for this user' };
  }

  // console.log(user);

  // Check through list of user identities for a match
  if (user.identities && user.identities.length) {
    for (const idType of requiredId) {
      if (idType === IdentityType.manual) {
        if (hasManualId) {
          return { ok: true, data: ' Manual id set for this user' };
        }
      } else {
        const idRecord = user.identities.find((ident) => ident.identityType === idType);
        if (idRecord) {
          return { ok: true, data: idRecord };
        }
      }
    }
  }

  return {
    ok: false,
    data: `No id found for ${requiredId}`,
  };
};

export const userHasRequiredIdFromList = function (
  user: CurrentUser,
  list: IdentityType[]
): boolean {
  if (!list || !list.length) {
    return true;
  }
  // User has no identities ?
  if (user.identities && user.identities.length) {
    for (const idType of list) {
      const ok = user.identities.find((ident) => ident.identityType === idType);
      if (ok) {
        return true;
      }
    }
  }

  return false;
};

// See if user has any role in organization using organizationId
// Throws error user does not have permission
export const userHasOrgPermissionById = function (
  permission: PermissionEnum,
  user: CurrentUser,
  organizationId: string
): boolean {
  return hasCurrentUserPermissions({
    currentUser: user,
    permissions: [permission],
    organizationId,
  });
};

// See if user has any client role in organization
export const hasClientPermissionOnOrg = function (
  user: CurrentUser,
  organization: Organization
): boolean {
  if (user.superuser || user.superclient) {
    return true;
  }

  if (!user || !user.client_admin) return false;

  const clientId = organization.clientId;

  if (!user.client_admin[clientId]) return false;
  return true;
};
